import { render, staticRenderFns } from "./cModalMaterials.vue?vue&type=template&id=13b1c0a4"
import script from "./cModalMaterials.vue?vue&type=script&lang=js"
export * from "./cModalMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports